"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1422],{

/***/ 21422:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(33616);
var _path, _path2, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgContratacionSegurosCircle = function SvgContratacionSegurosCircle(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "m26.248 19.386-3.662 5.492-2.568-2.57a.502.502 0 0 0-.708.709l3 3a.498.498 0 0 0 .354.146h.049a.501.501 0 0 0 .367-.221l4-6a.499.499 0 1 0-.832-.554v-.002Z",
    fill: "CurrentColor"
  })), _path2 || (_path2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M30.665 17.113a.5.5 0 0 0-.311-.414l-7.5-3a.5.5 0 0 0-.372 0l-7.5 3a.5.5 0 0 0-.317.414c-.01.1-.936 10.388 7.762 14.992a.5.5 0 0 0 .468 0c8.7-4.604 7.778-14.888 7.77-14.992Zm-8 13.982c-7.058-3.909-7.092-11.94-7.021-13.585l7.02-2.808 7.024 2.808c.077 1.644.045 9.67-7.023 13.585Z",
    fill: "CurrentColor"
  })), _rect || (_rect = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("rect", {
    x: 1.167,
    y: 1.163,
    width: 42,
    height: 42,
    rx: 21.5,
    stroke: "#765346"
  })));
};
/* harmony default export */ __webpack_exports__["default"] = (SvgContratacionSegurosCircle);

/***/ })

}]);